// src/components/admin/ResourceTable.js
import React from 'react';

// A generic table component to display lists of resources
const ResourceTable = ({ data, columns, onEdit, onDelete, title }) => {
  if (!data || data.length === 0) {
    return <p>No {title.toLowerCase()} found.</p>;
  }

  return (
    <div className="admin-table-wrapper">
      <table className="admin-table">
        <thead>
          <tr>
            {columns.map(col => <th key={col.key}>{col.label}</th>)}
            {(onEdit || onDelete) && <th style={{ width: '120px' }}>Actions</th>}
          </tr>
        </thead>
        <tbody>
          {data.map(item => (
            <tr key={item.id}>
              {columns.map(col => (
                <td key={col.key}>
                  {col.render ? col.render(item[col.key], item) : String(item[col.key])}
                </td>
              ))}
              {(onEdit || onDelete) && (
                <td className="admin-actions">
                  {onEdit && <button onClick={() => onEdit(item)} className="admin-button primary">Edit</button>}
                  {onDelete && <button onClick={() => onDelete(item)} className="admin-button danger">Delete</button>}
                </td>
              )}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default ResourceTable;